// Single source of truth: `GTV_STUDENT_SKU` lives in @inkitt/contracts-gtv. We import via the
// `/constants` subpath rather than the package barrel because the barrel re-exports the ts-rest
// routers, which fail to type-check here (TS4023 "cannot be named"). The subpath only pulls in the
// plain SKU constants, so the two stay aligned with no risk of drift.
import { GTV_STUDENT_SKU } from '@inkitt/contracts-gtv/constants';

export const STUDENT_SKUS: ReadonlySet<string> = new Set([GTV_STUDENT_SKU]);

export const isStudentSku = (sku: string): boolean => STUDENT_SKUS.has(sku);
